"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.App = void 0;
const gs_1 = require("@ivanlog/gs");
const State_1 = require("./states/abstracts/State");
const ProfiMallAPI_1 = require("./api/ProfiMallAPI");
const CacheController_1 = require("./appControllers/CacheController");
const AuthController_1 = require("./appControllers/AuthController");
const GUIController_1 = require("./appControllers/GUIController");
class App {
    static get Auth() { return App.Inst.auth; }
    get gui() { return this._gui; }
    set gui(value) { this._gui = value; }
    constructor() {
        this._instances = new Map();
        App.Inst = this;
        State_1.State.App = this;
        gs_1.StateGS.Initialize(true);
        gs_1.StateGS.DefaultStateName = 'loading';
        this.api = new ProfiMallAPI_1.ProfiMallAPI(App.API_URL + App.API_PATH, (e, args) => this._apiErrorHandler(e, args));
        this.cache = new CacheController_1.CacheController(this);
        this._gui = new GUIController_1.GUIController(this);
        this.addInst(GUIController_1.GUIController, this.gui);
        this.auth = new AuthController_1.AuthController(this);
        this.addInst(AuthController_1.AuthController, this.auth);
        // this.events = new EventsController(this);
        this.gui.initialize();
        this.auth.initialize();
    }
    getInst(cls) {
        const instance = this._instances.get(cls);
        if (!instance)
            throw new Error(`No instance found for ${cls.name}`);
        return instance;
    }
    addInst(cls, instance) {
        this._instances.set(cls, instance);
    }
    _apiErrorHandler(e, args) {
        if (args && args.callback) {
            args.callback(e, args);
            return;
        }
        if (args && args.skip)
            return;
        if (e) {
            if (e.code) {
                //if (e.code==401) {this.auth.dropAuthStateAsync(); return;}
                if (e.code == 422) { }
                if (e.code == 403) {
                    this.gui.showPopMessage(e.message);
                }
            }
            if (e.actionCode) {
                // const failed = new ResultFail(e);
                // this.gui.popInfoAsync(failed.message);
            }
        }
        console.log(e);
    }
}
exports.App = App;
App.API_URL = "http://127.0.0.1:5000";
App.API_PATH = "/";
App.MAP_API = "6f0a3ab7-d744-4144-b0d9-f8c68dac28c4";
App.MAP_SUGGEST_API = "3c0b35f0-92db-444f-976f-e4c2ff59211b";
App.DeliveryId = 2147483647;
//    public static EVENTS_URL:string = "http://127.0.0.1:6100";
App.FILES_PATH = App.API_URL; //+this.API_PATH+"files?fileId=";
//# sourceMappingURL=App.js.map